module.exports = __webpack_public_path__ + "img/rankingtwo.f384aa80.png";